/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import Label from "../../components/label";
import ChangePasswordForm from "../../containers/ChangePasswordForm";
import MakeAPICall from "../../apiCalls/common";
import { changePassword } from "../../apiRoutes";
import appRoutes from "../../routes/appRoutes";

class ChangePasswordPage extends Component {

  constructor(props){
    super(props);
    this.state = {
      apiCall: null,
    }
  }

  onChangePasswordform = formValues => {
    console.log("Change password Details form submitted : ", formValues);
    let bodyData = new FormData();
    bodyData.append('newPassword', formValues.newPassword);
    bodyData.append('oldPassword', formValues.oldPassword);
    let apiCallParam = {
      reqType: "PUT",
      reqURL: changePassword,
      dataObj: bodyData,
      params: {},
      headers: {},
      successCallback: res => {
        console.log("Success Msg : ", res.data.data);
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
      },
      showPopUp: true,
      redirect: appRoutes.dashboard
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="row rounded p-3 bank-edit-page">
        <div className="col-sm-12 p-3">
          <Label title="Change Password" className="big" />
        </div>
        <div className="w-100 border"></div>

        <div className="col-sm-12 mt-4">
          <ChangePasswordForm onFormSubmit={this.onChangePasswordform} />
        </div>
        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
      </div>
    );
  }
}

export default ChangePasswordPage;
